import script from "./MassActionsRowCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./MassActionsRowCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./MassActionsRowCheckbox.vue?vue&type=style&index=0&id=5a43272f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a43272f"]])

export default __exports__